import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./client";

// ────────────────────────────────────────────────────────────────
// One QueryClient for the whole app. Defaults tuned for an internal
// dashboard embedded in Microsoft Teams:
//
//   staleTime: 30s
//     Data stays "fresh" for 30s. Navigating away and back inside
//     that window serves cached data instantly with no refetch.
//     Teams users tab-switch a lot; this matters.
//
//   gcTime: 5 min
//     Unused query results sit in memory for 5 min before garbage
//     collection. Means quick back-button feels instant even after
//     a brief visit elsewhere.
//
//   refetchOnWindowFocus: false
//     The default (refetch every time the tab regains focus) is
//     great for live dashboards but noisy for an internal admin
//     app. User can hit the refresh button explicitly.
//
//   retry: smart
//     Retry transient network failures up to 2 times — but NEVER
//     retry auth/permission/not-found errors. Those won't fix
//     themselves and retrying just delays the inevitable error UI.
// ────────────────────────────────────────────────────────────────
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.status === 401 || error.status === 403 || error.status === 404) {
            return false;
          }
        }
        return failureCount < 2;
      },
    },
  },
});
